import { fontColor, primaryColor, webFont } from "../../config/theme";

const style = {
  bannerText: {
    fontFamily: "Poppins",
    color: fontColor,
    paddingBottom: 16,
    lineHeight: "64px",
    margin: 0,
    fontWeight: 500,
  },
  bannerTextR: {
    fontFamily: "Poppins",
    color: fontColor,
    paddingBottom: 16,
    lineHeight: "64px",
    margin: 0,
    fontWeight: 300,
    fontSize: 60,
  },
  bannerSubText: {
    color: '#fff',
    opacity: '0.9',
    fontSize: 18,
    lineHeight: '32px',
  },
  bannerGrid: {
    background: "rgba(0,0,0,.3)",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    display: 'flex',
    flexDirection: 'column',
    padding: '130px 0px',
  },
  subheading: {
    fontSize: "12px"
  },
  getStartedButton: {
    color: fontColor,
    backgroundColor: primaryColor,
    fontFamily: webFont,
    borderRadius: "35px",
    padding: "8px 7px 8px",
    fontSize: 18,
  },
  bannerButton: {
    color: fontColor,
    backgroundColor: primaryColor,
    fontFamily: webFont,
    borderRadius: "35px",
    padding: "0 10px",
    marginLeft: 24,
    marginBottom: "10px",
    fontSize: 18,
    fontWeight: 500,
    minWidth: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 56,
  },
  bannerButtonInverted: {
    color: primaryColor,
    backgroundColor: fontColor,
    fontFamily: webFont,
    borderRadius: "35px",
    padding: "0 10px",
    marginLeft: 24,
    marginBottom: "10px",
    fontSize: 18,
    fontWeight: 500,
    minWidth: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 56,
    '&:hover': {
      color: fontColor,
      backgroundColor: primaryColor,
      fontFamily: webFont,
      borderRadius: "35px",
      padding: "0 10px",
      marginLeft: 24,
      marginBottom: "10px",
    }
  },
  singleBtn: {
    minWidth: 240,
    minHeight: 56,
    fontWeight: 500
  },
  btnGridMobile: {
    // marginLeft: "70px"
  },
  bannerBtnImg: {
    marginRight: "5px",
    minWidth: 21,
  },
  btnBannerTxt: {
    fontSize: 18,
    marginLeft: 11,
  }
};

export default style;
